import React from 'react';
import { Card, CardContent, Typography, Button } from '@mui/material';

const FileCards = ({ files }) => {
  const handleCardClick = (link) => {
    window.open(link, '_blank'); // Open the link in a new window/tab
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      {files.map((file) => (
        <Card key={file.id} style={{ margin: '10px', minWidth: '250px' }}>
          <CardContent style={{
            cursor: 'pointer',
          }} onClick={() => handleCardClick(file.link)}
>
            <Typography variant="h6" component="div">
              Open Job Order File
            </Typography>
          
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default FileCards;
